import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const trackPageview = (page, path) => {
  axios.post(`${API}/track/pageview`, { page, path }).catch(() => {});
};

export const trackVideoClick = (video) => {
  axios.post(`${API}/track/video-click`, {
    video_id: video.id,
    video_title: video.title || '',
    related_product: video.related_product || '',
  }).catch(() => {});
};
